<lib-prod-form [fields]="fields"
               [showCancelButton]="false"
               [initializeFormEvent]="initializeFormEvent$"
               [data]="data"
               [style]="style"
               (onSubmitEvent)="submit($event)"></lib-prod-form>
